import React, { Component } from 'react';

import HelpfulInfoChildPageBase from '../HelpfulInfoChildPageBase';

interface OwnProps {}
interface OwnState {}

class EtaApply extends Component<OwnProps, OwnState> {
  render() {
    return <HelpfulInfoChildPageBase pageID={2829} />;
  }
}
export default EtaApply;
